import { useEffect } from 'react';
import { useLingui } from '@lingui/react/macro';

import { Button, Flex } from '@rover/kibble/core';
import ScrollableModal from '@rover/kibble/patterns/ScrollableModal';
import useOpenTractiveReferral from '@rover/react-lib/src/pages/contact-more-sitters/pages/PostRequestPage/SmartCollarModal/hooks/useOpenTractiveReferral';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import TestAContent from './components/TestAContent';
import TestBContent from './components/TestBContent';
import {
  SmartCollarCancelButtonClick,
  SmartCollarClaimButtonClick,
  SmartCollarCloseButtonClick,
  SmartCollarModalAppeared,
} from './analyticsEvents';
import { Entrypoint } from './types';

type Props = {
  open: boolean;
  onClose: () => void;
  discountCode: string;
  entrypoint: Entrypoint;
};

const SmartCollarModal = ({
  open,
  onClose,
  discountCode,
  entrypoint,
}: Props): JSX.Element | null => {
  const { t } = useLingui();
  const { openTractiveReferral } = useOpenTractiveReferral(discountCode);

  useEffect(() => {
    if (open) emitAnalyticsEvent(new SmartCollarModalAppeared(entrypoint));
  }, [entrypoint, open]);

  return (
    <ScrollableModal
      isOpen={open}
      onClose={() => {
        emitAnalyticsEvent(new SmartCollarCloseButtonClick(entrypoint));
        onClose();
      }}
      isSubmittable={false}
      isScrollable={false}
      isDismissable={false}
      showCloseIcon
      showCloseIconMobile
      data-testid="scrollable-modal"
    >
      <Flex
        width="100%"
        alignContent="center"
        justifyContent="center"
        flexDirection="column"
        height="auto"
        alignItems="center"
      >
        {entrypoint === Entrypoint.CMS ? <TestAContent /> : <TestBContent />}
      </Flex>

      <Flex flexDirection="column" mt="8x" gap="3x">
        <Button
          fullWidth
          variant="primary"
          onPress={() => {
            openTractiveReferral();

            emitAnalyticsEvent(new SmartCollarClaimButtonClick(entrypoint));
            onClose();
          }}
        >
          {t`Claim your free device`}
        </Button>
        <Button
          fullWidth
          variant="flat"
          onPress={() => {
            onClose();
            emitAnalyticsEvent(new SmartCollarCancelButtonClick(entrypoint));
          }}
        >
          {entrypoint === Entrypoint.CMS ? t`No thanks` : t`Not right now`}
        </Button>
      </Flex>
    </ScrollableModal>
  );
};

export default SmartCollarModal;
